/**
  AXIS JS setting function

  @since: 2020-04-06
  @author: tams_dev1
*/
const resultFactory = (commit, payload) => {
  if (payload.data.code === 'ok') { // 결과가 OK 인 경우
    if (payload.action !== null) {
      const item = payload.param === null ? payload.data.result : payload.param
      commit(payload.action, item)
    }
    return 'ok'
  }
  if (payload.data.code === 'nok') { // 결과가 NOK 인 경우
    if (payload.length !== null && payload.length !== 0 && payload.length > 1) { // 멀티 삭제 또는 멀티 수정이 가능한 기능에서 1개가 아닌 여러개를 시도한 경우.
      return {code: 'pok', errors: payload.data.result.errors}
    }
    return {code: 'nok', errors: payload.data.result.errors} // 그 외 nok 인 경우
  }
  if (payload.data.code === 'pok') { // 결과가 POK 인 경우
    return {code: 'pok', errors: payload.data.result.errors}
  }
  return {code: 'error', errors: payload.data.result.msg} // code 는 NOK 가 아니지만, 결과가 NOK 인 경우
}

export default resultFactory
